import React from 'react';
import { Plus } from 'lucide-react';

export const GalleryPanel = ({
  form, galleryUploading, galleryInputRef,
  handleGalleryFiles, removeGalleryImage,
}) => (
  <div className="panel" style={{ padding: 18, marginBottom: 14 }}>
    <label style={{ fontSize: 12.5, fontWeight: 600, display: 'block', marginBottom: 11 }}>
      Photo gallery <span className="hint">shown on your shop-front</span>
    </label>
    <div className="gallery" data-testid="gallery">
      {form.gallery_urls.map((url) => (
        <div key={url} className="ph-img" style={{ backgroundImage: `url(${url})` }}>
          <button type="button" className="rm" onClick={() => removeGalleryImage(url)} aria-label="Remove">
            ×
          </button>
        </div>
      ))}
      <label className="ph-img add" data-testid="gallery-add">
        {galleryUploading ? '…' : <Plus size={18} />}
        <input
          ref={galleryInputRef}
          type="file"
          accept="image/png,image/jpeg,image/webp"
          multiple
          onChange={(e) => handleGalleryFiles(e.target.files)}
          style={{ display: 'none' }}
          data-testid="gallery-input"
        />
      </label>
    </div>
    <div className="hint" style={{ marginTop: 8, fontSize: 11 }}>
      Recommended 1200 × 900 px (4:3). Uploaded as-is — no cropping.
    </div>
  </div>
);
